import React from 'react';
import './Direccion.css';

const Direccion = () => {
  const objectives = {
    cell1: 'MERCADO GLOBAL',
    cell2: 'Iniciamos y continuaremos expandiendo nuestros servicios a nivel global, convirtiéndonos en una empresa confiable a través de las fronteras, ya que contamos con la experiencia y los conocimientos para llevar nuestros especialistas y los recursos necesarios a cualquier punto.',
    cell3: 'EXCELENCIA Y CALIDAD',
    cell4: 'Ejecutar proyectos en cumplimiento con los mas altos estándares de calidad a nivel mundial, siempre en el tiempo previsto y salvaguardando la integridad de nuestros colaboradores, lo cual nos lleva a lograr la excelencia en nuestros proyectos.',
  };

  return (
    <div className="direccion-section">
      <div className="container">
        <h1 className="main-title">Dirección</h1>

        <div className="direction-content">
          <h2 className="section-title">A donde nos dirigimos...</h2>
          <p className="direction-text">
            Buscamos posicionarnos como la solución para lograr los objetivos de nuestros clientes, no solo en el mercado nacional sino a nivel global, siendo una empresa confiable para sus proyectos.
          </p>
        </div>

        {/* Estadísticas */}
        <div className="stats-grid">
          <div className="stat-card">
            <h2 className="stat-number">160,000+</h2>
            <p className="stat-description">M2 de instalación de geomembrana</p>
          </div>

          <div className="stat-card">
            <h2 className="stat-number">10,000+</h2>
            <p className="stat-description">Pulgadas diam de tuberías instaladas</p>
          </div>

          <div className="stat-card">
            <h2 className="stat-number">1,500+</h2>
            <p className="stat-description">Metros lineales de tuberías aisladas</p>
          </div>

          <div className="stat-card">
            <h2 className="stat-number">400+</h2>
            <p className="stat-description">Toneladas de Estructura Metálica</p>
          </div>
        </div>

        {/* Sectores industriales */}
        <div className="sectors-section">
          <div className="sectors-grid">
            <div className="sector-card">
              <h3>Oil & Gas</h3>
            </div>
            <div className="sector-card">
              <h3>Energía</h3>
            </div>
            <div className="sector-card">
              <h3>Minería</h3>
            </div>
          </div>

          <p className="sectors-description">
            Desarrollamos proyectos industriales en los diferentes sectores (Oil
            & Gas, Energía y Minería, ) aplicando nuestra experiencia y
            capacidad para lograr los objetivos de los proyectos.
          </p>
        </div>

        {/* Objetivos */}
        <div className="objectives-section">
          <h1 className="objectives-title">Objetivos</h1>
          <div className="objectives-table">
            <div className="table-row">
              <div className="table-cell">
                <h3>{objectives.cell1}</h3>
              </div>
              <div className="table-cell">
                <p>{objectives.cell2}</p>
              </div>
            </div>
            <div className="table-row">
              <div className="table-cell">
                <h3>{objectives.cell3}</h3>
              </div>
              <div className="table-cell">
                <p>{objectives.cell4}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Direccion;